<div class="headerOptions">
  <div class="headerOptions__option" (click)="toggleAllPoints()">
    <p class="headerOptions__text">
      {{ (allSelected ? 'deselect_all' : 'select_all') | ppTranslate }}
    </p>
  </div>

  @if (collapsed) {
    <div class="headerOptions__option" (click)="expandGroup()">
      <p class="headerOptions__text">{{ 'expand_all' | ppTranslate }}</p>
    </div>
  }

  @if (!collapsed) {
    <div class="headerOptions__option" (click)="collapseGroup()">
      <p class="headerOptions__text">{{ 'collapse_all' | ppTranslate }}</p>
    </div>
  }
</div>
